import { IOrderItem } from "~/graphql/queries/order/orderByNumberAndPostalCode";

export function getProductDisplayNameFromOrderItem(orderItem: IOrderItem) {
  if (!orderItem.product || !orderItem.product.titles) {
    return null;
  }

  const [title] = orderItem.product.titles;

  if (!title || !title.translations) {
    return null;
  }

  const { translations: [translation = null] = [] } = title;

  return translation ? translation.value : null;
}



// WEBPACK FOOTER //
// ./src/util/productTitle.ts